<template>
  <ExhibitionContainer
    :trade-show-name="'Retail Tech Show 2026'"
    :activation-message="'Please scan your badge QR code'"
    has-badge-number-input
    :ble-id="label_id"
    :asset-id="asset_id"
    :token="t"
    :form-id="hubspotIds.formId"
    :portal-id="hubspotIds.portalId"
    :region="hubspotIds.region"
  >
    <template slot="banner">
      <Banner
        booth-number="Stand F60"
      />
    </template>
  </ExhibitionContainer>
</template>
<script>
import ExhibitionContainer from '../../components/organisms/exhibitions/exhibition-container';
import Banner from '../../components/molecules/exhibitions/retail-tech-show-2026-banner';

export default {
  name: 'RetailTechShow2026',
  components: {
    ExhibitionContainer,
    Banner,

  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    label_id: { type: String, required: true },
    // eslint-disable-next-line vue/prop-name-casing
    asset_id: { type: String, required: true },
    t: { type: String, default: '' },
  },
  computed: {
    hubspotIds() {
      return {
        formId: process.env.VUE_APP_RETAIL_TECH_SHOW_FORM_ID,
        portalId: process.env.VUE_APP_RETAIL_TECH_SHOW_PORTAL_ID,
        region: process.env.VUE_APP_RETAIL_TECH_SHOW_REGION,
      };
    },
  },
};
</script>
